<template>
  <BaseButtonCircle @click.native="share">
    <img src="@/assets/img/twitter.svg"/>
  </BaseButtonCircle>
</template>

<script>
import BaseButtonCircle from '@/components/BaseButtonCircle/BaseButtonCircle'
import TwitterService from '@/services/TwitterService'
export default {
  components: {
    BaseButtonCircle
  },
  props: {
    url: {
      type: String,
      required: true
    },
    quote: {
      type: String,
      required: false
    }
  },
  methods: {
    share () {
      TwitterService.openShareDialogue(this.url, this.quote)
      this.$ga.event('share', 'twitter')
    }
  }
}
</script>

<style lang="scss" scoped>
img {
  height: 28%;
  width: auto;
  display: block;
}
</style>
